// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__2mgMD","border":"styles_border__1JO-s"};